"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatATagInHtml = exports.doComponentsUploadEvent = exports.doComponentsStyleEvent = exports.doComponentsBgColorEvent = void 0;
// 处理cms组件背景色逻辑，当没有设置bgcolor的时候沿用以前的styleItem逻辑，#EEF5FF的时候支持渐变色
const styleObj = [{
  background: '#FFF'
}, {
  backgroundImage: 'linear-gradient(180deg, #DAE5F2 0%, #FFFFFF 100%)'
}, {
  background: '#FFF'
}, {
  background: '#F5F7FA'
}];
const doComponentsBgColorEvent = (bgColor, index = 0) => {
  // if (!bgColor) {
  //   return styleObj[index];
  // }
  if (bgColor.toLocaleUpperCase() === '#EEF5FF') {
    return {
      backgroundImage: 'linear-gradient(180deg, #DAE5F2 0%, #FFFFFF 100%)'
    };
  }
  return {
    backgroundColor: bgColor
  };
};

/**
 * 对html中的a标签进行处理，加上上报参数
 * @param {string} htmlString 字符串格式的html内容
 * @returns {string} 处理后的html内容
 */
exports.doComponentsBgColorEvent = doComponentsBgColorEvent;
const formatATagInHtml = (htmlString, reportEvent) => {
  let ret = htmlString;
  try {
    ret = htmlString.replace(/<a(.*?href=["'])(.+?)(["'].*?)>(.*?)<\/a>/g, (match, p1, href, p3, text) => {
      const reportEventProperties = `report-event-goal="click_richtext_href" report-event="${reportEvent}" report-ext1="${text}" report-ext2="${href}"`; // 上报用的属性
      const handled = `<a${p1}${href}${p3} ${reportEventProperties} >${text}</a>`;
      return handled;
    });
  } catch (e) {}
  return ret;
};

// 对upload组件中上传新增alt属性的对象解析
exports.formatATagInHtml = formatATagInHtml;
const doComponentsUploadEvent = uploadStr => {
  let alt = '';
  let url = '';
  let id = '';
  if (uploadStr) {
    try {
      let obj = JSON.parse(uploadStr);
      alt = obj.alt || '';
      url = obj.url || '';
      id = obj.id || '';
      return {
        alt,
        url,
        id
      };
    } catch (err) {
      return {
        alt,
        url: uploadStr
      };
    }
  }
  return {
    alt,
    url
  };
};

//处理gems配置的公共样式
exports.doComponentsUploadEvent = doComponentsUploadEvent;
const doComponentsStyleEvent = ({
  color = '',
  gradientColor = '',
  paddingTopNum = '',
  paddingBottomNum = ''
}) => {
  let style = {
    backgroundColor: '',
    paddingTop: '',
    paddingBottom: '',
    backgroundImage: ''
  };
  if (color) {
    style.backgroundColor = color;
  }
  if (gradientColor) {
    style.backgroundImage = gradientColor;
  }
  if (paddingTopNum) {
    style.paddingTop = `${paddingTopNum}px`;
  }
  if (paddingBottomNum) {
    style.paddingBottom = `${paddingBottomNum}px`;
  }
  return style;
};
exports.doComponentsStyleEvent = doComponentsStyleEvent;